import React from "react";
import styles from "./index.module.scss";
import { Chart as ChartJS, CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend } from "chart.js";
import { Line } from "react-chartjs-2";

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend);

function DailyConsultation({ consultationCount, selectedSpan }) {
	// Extract months (labels) and consultation values
	const labels = Object.keys(consultationCount);
	const dataValues = Object.values(consultationCount);

	// Determine the maximum value for the y-axis range
	const maxValue = Math.max(...dataValues);
	// Round up maxValue to the nearest multiple of 5 or 10
const dynamicMax = Math.ceil((maxValue + 1) / 5) * 5;

// Determine a clean step size based on dynamicMax
let dynamicStepSize;
if (dynamicMax <= 5) {
  dynamicStepSize = 1;
} else if (dynamicMax <= 20) {
  dynamicStepSize = 2;
} else if (dynamicMax <= 50) {
  dynamicStepSize = 5;
} else {
  dynamicStepSize = 10;
}

	const hasData = dataValues.some((val) => val > 0); // Check if there's any non-zero data

	const getXAxisLabel = () => {
		switch (selectedSpan.toLowerCase()) {
			case "daily":
				return "Hours";
			case "weekly":
				return "Days";
			case "monthly":
				return "Days";
			default:
				return "Days";
		}
	};

	const options = {
		maintainAspectRatio: false,
		responsive: true,
		plugins: {
			legend: {
				display: false,
				position: "bottom",
			},
			title: {
				display: false,
				text: "Consultations Over Months",
			},
			datalabels: {
				anchor: "top",
				align: "top",
				formatter: (value) => value,
			},
		},
		layout: {
			padding: {
				top: 0,
				bottom: 0,
			},
		},
		scales: {
			x: {
				display: true,
				title: {
					display: true,
					text: getXAxisLabel(),
				},
				grid: {
					drawTicks: false,
				},
				ticks: {
					padding: 10,
				},
			},
			y: {
				offset: 5,
				display: true,
				title: {
					display: true,
					text: "Number of Consultations",
				},
				grid: {
					drawTicks: false,
				},
				ticks: {
    beginAtZero: true,
    stepSize: dynamicStepSize,
    precision: 0,
    padding: 10,
  },
  max: dynamicMax,
},
		},
	};

	const data = {
		labels,
		datasets: [
			{
				label: "Consultations",
				data: dataValues,
				borderColor: "rgb(53, 162, 235)",
				backgroundColor: "rgba(53, 162, 235, 0.5)",
			},
		],
	};

	return (
		<div style={{ height: "280px", width: "100%", position: "relative" }}>
			{hasData ? (
				<Line options={options} data={data} />
			) : (
				<div
					style={{
						position: "absolute",
						top: 0,
						left: 0,
						right: 0,
						bottom: 0,
						display: "flex",
						alignItems: "center",
						justifyContent: "center",
						backgroundColor: "#f9f9f9",
						border: "1px solid #e0e0e0",
						borderRadius: "8px",
					}}
				>
					<span style={{ color: "#999" }}>No consultations to display</span>
				</div>
			)}
		</div>
	);
}

export default DailyConsultation;
